import { inject, signal, Signal } from '@angular/core';
import {
  ApiDataAccess,
  ReadonlyHttpApiCollectionRepository,
  ReadonlyRepositoryCollectionService,
} from '@softline/core';
import { SOFTLINE_API_PMS_ROSTER_ABSENCE } from '../roster.api';
import { Absence } from '../types/absence';

export class RosterAbsenceService extends ReadonlyRepositoryCollectionService<
  Absence,
  Absence[],
  null
> {
  override params: Signal<null> = signal(null);

  constructor() {
    super(inject(RosterAbsenceRepository));
  }

  protected override getAll(result: Absence[] | null | undefined): Absence[] {
    return result ?? [];
  }
}

export class RosterAbsenceRepository extends ReadonlyHttpApiCollectionRepository<
  Absence[],
  null
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_PMS_ROSTER_ABSENCE);
  }
}

export const provideRosterAbsenceService = () => [
  RosterAbsenceRepository,
  RosterAbsenceService,
];
